/** Persisted so the top bar can match the Rails session current group after reload. */
export const CURRENT_GROUP_STORAGE_KEY = "cmCurrentGroupId";
